export default __webpack_public_path__ + "static/media/UHS_Logo_RGB_600px_200px.88ab7fa5.png";